// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import Html5FilledSvg from "@ant-design/icons-svg/es/asn/Html5Filled";
import AntdIcon from '../components/AntdIcon';

var Html5Filled = function Html5Filled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: Html5FilledSvg
  }));
};

Html5Filled.displayName = 'Html5Filled';
export default React.forwardRef(Html5Filled);